import { Link, useLocation } from 'react-router-dom';

const ITEMS = [
  { label: '首页', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', to: '/' },
  { label: '分类', icon: 'ri-grid-line', activeIcon: 'ri-grid-fill', to: '/category/movie' },
  { label: '搜索', icon: 'ri-search-line', activeIcon: 'ri-search-line', to: '/search' },
  { label: '关于', icon: 'ri-information-line', activeIcon: 'ri-information-fill', to: '/about' },
];

export default function BottomNav() {
  const { pathname } = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-background-200 bg-background-50/95 backdrop-blur md:hidden">
      <div className="flex h-16 items-stretch">
        {ITEMS.map((item) => {
          const active = item.to === '/' ? pathname === '/' : pathname.startsWith(item.to);
          return (
            <Link
              key={item.label}
              to={item.to}
              className={`flex flex-1 flex-col items-center justify-center gap-1 text-xs font-medium transition-colors ${
                active ? 'text-primary-600' : 'text-foreground-500'
              }`}
            >
              <span className="flex h-6 w-6 items-center justify-center">
                <i className={`${active ? item.activeIcon : item.icon} text-xl`} />
              </span>
              {item.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}